import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

export function formatNumber(num) {
  return new Intl.NumberFormat('en-US').format(num);
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });
}

// Calculate pitch factor for roof area
export function getPitchFactor(pitch) {
  // Pitch is rise over 12 run
  const pitchFactors = {
    0: 1.000, 1: 1.003, 2: 1.014, 3: 1.031, 4: 1.054,
    5: 1.083, 6: 1.118, 7: 1.158, 8: 1.202, 9: 1.250,
    10: 1.302, 11: 1.357, 12: 1.414, 13: 1.474, 14: 1.537,
    15: 1.601, 16: 1.667, 17: 1.734, 18: 1.803
  };
  return pitchFactors[pitch] || 1.0;
}

// Calculate polygon area from coordinates
export function calculatePolygonArea(coordinates) {
  if (!coordinates || coordinates.length < 3) return 0;
  
  let area = 0;
  const n = coordinates.length;
  
  for (let i = 0; i < n; i++) {
    const j = (i + 1) % n;
    area += coordinates[i][0] * coordinates[j][1];
    area -= coordinates[j][0] * coordinates[i][1];
  }
  
  return Math.abs(area / 2);
}

// Convert meters squared to feet squared
export function sqMetersToSqFeet(sqMeters) {
  return sqMeters * 10.7639;
}

// Convert meters to feet
export function metersToFeet(meters) {
  return meters * 3.28084;
}

export const ROOF_MATERIAL_LABELS = {
  asphalt_shingle: 'Asphalt Shingle',
  tile: 'Tile',
  metal: 'Metal',
};

// Self-describing material line items for a report's materials, with a legacy
// fallback for older reports saved before material_lines existed (asphalt shingle).
export function getMaterialLines(materials) {
  const m = materials || {};
  if (Array.isArray(m.material_lines) && m.material_lines.length > 0) return m.material_lines;
  return [
    { key: 'shingle_bundles', label: 'Shingle Bundles', qty: m.shingle_bundles || 0, unit: 'bundles' },
    { key: 'underlayment_rolls', label: 'Underlayment Rolls', qty: m.underlayment_rolls || 0, unit: 'rolls' },
    { key: 'decking_sheets', label: 'Decking Sheets (4x8)', qty: m.decking_sheets || 0, unit: 'sheets' },
    { key: 'nails_lbs', label: 'Roofing Nails', qty: m.nails_lbs || 0, unit: 'lbs' },
    { key: 'starter_bundles', label: 'Starter Strip', qty: m.starter_bundles || 0, unit: 'bundles' },
    { key: 'ice_water_rolls', label: 'Ice & Water Shield', qty: m.ice_water_rolls || 0, unit: 'rolls' },
    { key: 'drip_edge_ft', label: 'Drip Edge', qty: m.drip_edge_ft || 0, unit: 'lin ft' },
    { key: 'ridge_bundles', label: 'Ridge Cap', qty: m.ridge_bundles || 0, unit: 'bundles' },
  ];
}
